type Props = {};

const AllowPopup = (props: Props) => {
    return (

<body>
    <div className="container-fluid vh-100">
        <div className="row h-100">
            {/* <!-- Left --> */}
            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center background-login">
                {/* <img src="logo.svg" className="img-fluid" alt="Gradmap" /> */}
                <img alt="GradMap logo" src="../assets/images/login-logo-blue.png" className="login-logo"></img>
            </div>

            {/* <!-- Right --> */}
            <div className="col-lg-8 col-12 d-flex align-items-center">``
                <div className="container py-5" style={{maxWidth: "720px;"}}>

    <div className="row justify-content-center p-5">
        <div className="col-md-12">

            <h1 className="mb-4">How to Allow Pop-ups in Your Browser</h1>

            <div className="alert alert-warning">
                <strong>Unable to open CAM?</strong><br/>
                Your browser may have blocked the pop-up window. Please enable
                pop-ups for this site and try again.
            </div>

            {/* <!-- Apple Safari --> */}
            <div className="card mb-4">
                <div className="card-header">
                    <h2 className="h5 mb-0">🍎 Apple Safari</h2>
                </div>

                <div className="card-body">

                    <h3 className="h6">Safari on iPhone and iPad</h3>

                    <p>
                        <strong>Official Guide:</strong><br/>

                        <a href="https://support.apple.com/102524"
                           target="_blank"
                           rel="noopener noreferrer">
                            Block pop-up ads and windows in Safari
                        </a>
                    </p>

                    <ol>
                        <li>Open <strong>Settings</strong>.</li>
                        <li>Tap <strong>Apps</strong> → <strong>Safari</strong>.</li>
                        <li>Turn <strong>Block Pop-ups</strong> <strong>Off</strong>.</li>
                        <li>Return to the application and try opening CAM again.</li>
                    </ol>

                    <hr/>

                    <h3 className="h6">Safari on macOS</h3>

                    <p>
                        <strong>Official Guide:</strong><br/>

                        <a href="https://support.apple.com/guide/safari/allow-or-block-pop-ups-sfri40696/mac"
                           target="_blank"
                           rel="noopener noreferrer">
                            Allow or block pop-ups in Safari on Mac
                        </a>
                    </p>

                </div>
            </div>

            {/* <!-- Google Chrome --> */}
            <div className="card mb-4">
                <div className="card-header">
                    <h2 className="h5 mb-0">🌐 Google Chrome</h2>
                </div>

                <div className="card-body">

                    <h3 className="h6">Chrome on Desktop</h3>

                    <p>
                        <strong>Official Guide:</strong><br/>

                        <a href="https://support.google.com/chrome/answer/95472"
                           target="_blank"
                           rel="noopener noreferrer">
                            Block or allow pop-ups in Chrome
                        </a>
                    </p>

                    <hr/>

                    <h3 className="h6">Chrome on iPhone and iPad</h3>

                    <p>
                        Chrome on iOS uses Apple's WebKit engine and follows
                        the system/browser behavior for pop-ups.
                    </p>

                    <p>
                        Official Guide:<br/>

                        <a href="https://support.google.com/chrome/answer/95472"
                           target="_blank"
                           rel="noopener noreferrer">
                            Block or allow pop-ups in Chrome
                        </a>
                    </p>

                </div>
            </div>

            {/* <!-- Microsoft Edge --> */}
            <div className="card mb-4">
                <div className="card-header">
                    <h2 className="h5 mb-0">🟦 Microsoft Edge</h2>
                </div>

                <div className="card-body">
                    <p>
                        Visit Microsoft Support:
                    </p>

                    <p>
                        <a href="https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5"
                           target="_blank"
                           rel="noopener noreferrer">
                            Microsoft Edge Support
                        </a>
                    </p>

                    <p>
                        Search for:
                    </p>

                    <ul>
                        <li><code>How to allow pop-ups</code></li>
                    </ul>
                </div>
            </div>

            {/* <!-- Help --> */}
            <div className="alert alert-info mb-0">
                <h2 className="h5">Still Need Help?</h2>

                <p className="mb-0">
                    If you have enabled pop-ups and CAM still does not open, please contact your system administrator or <a href="mailto:info@gradmap.com" target="_blank" rel="noreferrer noopener">Support team</a>&nbsp; for further assistance.
                </p>
            </div>

        </div>
    </div>
    <style scoped>{`
.background-login {
  background-image: url("/assets/images/bg-login.png");
  background-size: cover;
}
iframe#userpilot-checklist {
  display: none !important;
}
`}</style>

                </div>
            </div>

        </div>
    </div>
</body>

    );
}


export default AllowPopup;